import './InputAlertMessage.css';

export type InputAlertModel = {
	message: string;
	type: 'success' | 'warning' | 'error';
};

export const InputAlertMessage = ({ message, type }: InputAlertModel): JSX.Element => {
	return (
		<div>
			<span key={message} className={`input-alert ${type}`}>
				{message}
			</span>
		</div>
	);
};
